import React           from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCalendar } from './useCalendar'

import CalendarLeft  from './calendar-left'
import CalendarRight from './calendar-right'
import SmallCard     from './smallCard'
import TooltipPopup  from './tooltip-popup'
import AbsenceModal  from '../absences/AbsenceModal'

const Calendar = () => {
  const { state, fetchAllEvents, toggleLeftColumn, closeAbsenceModal } = useCalendar()

  return(
    <div>
      <div className={`calendar-grid${state.leftCollapsed ? ' left-collapsed' : ''}`}>
        <CalendarLeft />

        {/* Compact toggle: collapse / expand the whole left column */}
        <div
          className = "calendar-collapse-strip"
          onClick   = {toggleLeftColumn}
          title     = {I18n.t(state.leftCollapsed ? 'calendar.expand_column' : 'calendar.collapse_column')}
        >
          <FontAwesomeIcon icon="table-columns" />
        </div>

        <CalendarRight />
        <SmallCard />
        <TooltipPopup showPopup={state.showPopup} />

        <button
          className="hidden"
          id='calendar-refetch'
          onClick= {() => fetchAllEvents()}
        >
        </button>
      </div>

      { state.absenceModal &&
        <AbsenceModal
          prefill = {state.absenceModal}
          onClose = {closeAbsenceModal}
          onSaved = {fetchAllEvents}
        />
      }
    </div>
  )
}

export default Calendar
